import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { useCart } from "../context/CartContext";
import { formatINR } from "../data/products";
import { Reveal } from "./Reveal";

export const Stars = ({ rating, className = "" }) => (
  <span className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${rating} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        size={12}
        strokeWidth={1.2}
        className={i <= Math.round(rating) ? "fill-gold text-gold" : "text-beige"}
      />
    ))}
  </span>
);

export const ProductCard = ({ product, index = 0 }) => {
  const { add } = useCart();
  return (
    <Reveal delay={(index % 4) * 0.08}>
      <div className="group" data-testid={`product-card-${product.slug}`}>
        <Link
          to={`/product/${product.slug}`}
          data-testid={`product-link-${product.slug}`}
          className="relative block aspect-[4/5] overflow-hidden bg-cream"
        >
          <img
            src={product.image}
            alt={`${product.name} — ${product.fragrance} scented luxury candle`}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <span className="absolute left-4 top-4 bg-ivory/90 px-3 py-1 text-[9px] uppercase tracking-[0.2em] text-cocoa">
            {product.fragrance}
          </span>
          <button
            onClick={(e) => {
              e.preventDefault();
              add(product.slug);
            }}
            data-testid={`product-add-to-cart-${product.slug}`}
            className="absolute inset-x-0 bottom-0 hidden translate-y-full bg-cocoa/95 py-4 text-[10px] uppercase tracking-[0.28em] text-cream transition-all duration-500 ease-out hover:bg-gold group-hover:translate-y-0 md:block"
          >
            Add to Cart
          </button>
        </Link>
        <div className="pt-5 text-center">
          <Link
            to={`/product/${product.slug}`}
            className="font-serif text-xl text-ink transition-colors hover:text-gold"
          >
            {product.name}
          </Link>
          <p className="mt-1 text-[10px] uppercase tracking-[0.2em] text-taupe">{product.category}</p>
          <div className="mt-2 flex items-center justify-center gap-2">
            <Stars rating={product.rating} />
            <span className="text-[11px] text-taupe">({product.reviews})</span>
          </div>
          <p className="mt-2 text-sm font-medium tracking-wide text-ink" data-testid={`product-price-${product.slug}`}>
            {formatINR(product.price)}
          </p>
          <button
            onClick={() => add(product.slug)}
            data-testid={`product-add-to-cart-mobile-${product.slug}`}
            className="mt-4 w-full border border-cocoa/30 py-3 text-[10px] uppercase tracking-[0.25em] text-cocoa transition-colors hover:border-gold hover:text-gold md:hidden"
          >
            Add to Cart
          </button>
        </div>
      </div>
    </Reveal>
  );
};
